import { session, appState, EP, THU_IMIE, API_BASE } from '../config.js';
import { fmt } from '../format.js';
import { ICONS, hydrateIcons, svg } from '../icons.js';
import { lineChart } from '../chart.js';
import { DEMO, demoDay } from '../demo.js';
import { apiGet, apiPost, apiPut, noData, imieFor } from '../api.js';
import { C, spinner, emptyRow, toast } from '../ui.js';
import { closeModal } from '../modal.js';
import { go } from '../router.js';
import { applyRole, canDelete } from '../auth.js';

export let dashDates=[], dashDate='';

export async function viewDashboard(){
  C().innerHTML=`<div class="stats" id="statRow">
    ${statCard('TOTAL WEIGHT','—','Across all plants')}${statCard('MONTHLY','—','This month so far')}
    ${statCard('WEEKLY','—','This week so far')}${statCard('TODAY','—','Today so far')}</div>
  <div class="panel"><div class="panel-head"><h2>Conveyor Reading Overview</h2>
      <select class="datesel" id="dashDateSel" onchange="setDashDate(this.value)"></select></div>
    <div class="panel-body"><div class="chartwrap"><span class="ylab">Weight</span>
      <div style="flex:1"><div id="dashChart">${spinner}</div><div class="chart-axis" id="dashAxis">Time</div></div></div></div></div>
  <div class="panel"><div class="panel-head"><h2>Conveyor Readings (Last 30 Days)</h2></div>
    <div class="panel-body" style="padding:0"><table><thead><tr><th>Date</th><th>Total Weight</th></tr></thead>
    <tbody id="convBody"><tr><td colspan="2">${spinner}</td></tr></tbody></table></div></div>`;
  loadCards(); loadConveyorList();
}

export function statCard(t,v,sub){return `<div class="stat"><div class="t">${t}</div><div class="v">${v}</div><div class="sub2">${sub}</div></div>`}

export async function loadCards(){
  let c=DEMO.cards;
  try{const r=await apiGet('GetApi.php',{ID:session.IMIE,TableName:'DashBoardCards'});const d=await r.json();if(Array.isArray(d)&&d[0])c=d[0]}catch(e){appState.OFFLINE=true;applyRole()}
  const row=document.getElementById('statRow');if(!row)return;
  row.innerHTML=`${statCard('TOTAL WEIGHT',fmt(c.TotalWeight)+'<span class="unit">kg</span>','Across all plants')}
    ${statCard('MONTHLY',fmt(c.Monthly)+'<span class="unit">kg</span>','This month so far')}
    ${statCard('WEEKLY',fmt(c.Weekly)+'<span class="unit">kg</span>','This week so far')}
    ${statCard('TODAY',fmt(c.Today)+'<span class="unit">kg</span>','Today so far')}`;
}

export async function loadConveyorList(){
  let rows=DEMO.auto;
  try{const r=await apiGet('GetApi.php',{ID:session.IMIE,TableName:EP.autoList});const d=await r.json();
    if(!noData(d))rows=d.map(x=>[x.Date,Number(x['SUM(Weight)']??x.Total??0)])}catch(e){appState.OFFLINE=true;applyRole()}
  // populate the table
  const tb=document.getElementById('convBody');
  if(tb)tb.innerHTML = rows.length? rows.map(r=>`<tr><td style="font-weight:600">${r[0]}</td><td class="num">${fmt(r[1])}</td></tr>`).join('') : emptyRow(2,'No data available for the last 30 days');
  // populate the date dropdown + chart
  dashDates=rows.map(r=>r[0]); dashDate=dashDates[0]||'';
  const sel=document.getElementById('dashDateSel');
  if(sel)sel.innerHTML=dashDates.map(d=>`<option ${d===dashDate?'selected':''}>${d}</option>`).join('')||'<option>—</option>';
  renderDashChart();
}

export function setDashDate(v){dashDate=v;renderDashChart()}

export async function renderDashChart(){
  const el=document.getElementById('dashChart');if(!el)return;el.innerHTML=spinner;
  const ax=document.getElementById('dashAxis');if(ax)ax.textContent='Time — '+(dashDate||'');
  let pts=[];
  try{const r=await apiPost('GetApi.php',{ID:session.IMIE,TableName:EP.chartByDate},{Date1:dashDate});const d=await r.json();
    if(!noData(d))pts=d.map(x=>[x.Time,Number(x.Weight)])}catch(e){appState.OFFLINE=true;applyRole()}
  if(!pts.length){pts=demoDay(dashDate||'').map(x=>[x.Time,x.Weight])}
  el.innerHTML=lineChart(pts);
}

/* ============================================================
   OPERATIONS  —  Automatic + Manual (per plant)
   ============================================================ */
